// @ts-strict-ignore
import React from 'react'
import { Card } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { StandardWidth, classList } from 'services/styles'
import useStyles from './styles'

export interface IPageContentProps extends React.HTMLProps<HTMLDivElement> {
  card?: boolean
  maxWidth?: StandardWidth
}

function getStyle(style: React.CSSProperties, width: number): React.CSSProperties {
  const maxWidth = width ? `min(${width}px, calc(100vw - 24px))` : 'calc(100vw - 24px)'

  if (style) {
    return {
      ...style,
      maxWidth: maxWidth,
    }
  }

  return {
    maxWidth: maxWidth,
  }
}

const PageContent: React.FunctionComponent<IPageContentProps> = (props) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const { children, className, card, maxWidth, style, ...restProps } = props
  const containerClassName = classList(classes.container, className)
  const containerStyle = getStyle(style, theme.breakpoints.values[maxWidth])

  if (card) {
    return (
      <Card raised className={containerClassName} style={containerStyle} {...restProps as any}>
        {children}
      </Card>
    )
  }

  return (
    <div className={containerClassName} style={containerStyle} {...restProps}>
      {children}
    </div>
  )
}

export default PageContent
